import {
    NgModule
  } from '@angular/core';

import {
    BrowserModule
  } from '@angular/platform-browser';
  
  import {
    WmsRatesGroupComponent 
  } from './wms-rates-group.component';
  
  
import {
  NbIconModule,
  NbIconLibraries,
  NbToggleModule,
  NbTooltipModule
} from '@nebular/theme';

  import {
    HeaderModule
  } from '../header/header.module';

  import {
    OrderedListModule
  } from '../ordered-list/ordered-list.module'

  import {
    LabelInlineEditModule
  } from '../label-inline-edit/label-inline-edit.module';
  
  import { FormsModule } from '@angular/forms';
  
  @NgModule({
    declarations: [
      WmsRatesGroupComponent
    ],
    imports: [
      BrowserModule,
      HeaderModule,
      OrderedListModule,
      NbIconModule,
      LabelInlineEditModule,
      NbToggleModule,
      FormsModule,
      NbTooltipModule
    ],
    exports: [
      WmsRatesGroupComponent
    ]
  })
  export class WmsRatesGroupModule { 
    constructor(private iconLibraries: NbIconLibraries) {
      this.registerSvgIcons();
    }
  
    private registerSvgIcons() {
        this.iconLibraries.registerSvgPack('custom', {
          'editLabel': `<svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1894_120)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.17417 2.42417C1.52581 2.07254 2.00272 1.875 2.5 1.875H6.875C7.22018 1.875 7.5 2.15482 7.5 2.5C7.5 2.84518 7.22018 3.125 6.875 3.125H2.5C2.33424 3.125 2.17527 3.19085 2.05806 3.30806C1.94085 3.42527 1.875 3.58424 1.875 3.75V12.5C1.875 12.6658 1.94085 12.8247 2.05806 12.9419C2.17527 13.0592 2.33424 13.125 2.5 13.125H11.25C11.4158 13.125 11.5747 13.0592 11.6919 12.9419C11.8092 12.8247 11.875 12.6658 11.875 12.5V8.125C11.875 7.77982 12.1548 7.5 12.5 7.5C12.8452 7.5 13.125 7.77982 13.125 8.125V12.5C13.125 12.9973 12.9275 13.4742 12.5758 13.8258C12.2242 14.1775 11.7473 14.375 11.25 14.375H2.5C2.00272 14.375 1.52581 14.1775 1.17417 13.8258C0.822544 13.4742 0.625 12.9973 0.625 12.5V3.75C0.625 3.25272 0.822544 2.77581 1.17417 2.42417Z" fill="#232B43"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 1.79907C12.3141 1.79907 12.1359 1.87291 12.0045 2.00434L6.18937 7.81943L5.85899 9.14092L7.18048 8.81055L12.9956 2.99546C13.127 2.86403 13.2008 2.68577 13.2008 2.4999C13.2008 2.31403 13.127 2.13577 12.9956 2.00434C12.8641 1.87291 12.6859 1.79907 12.5 1.79907ZM11.1206 1.12046C11.4864 0.754605 11.9826 0.549072 12.5 0.549072C13.0174 0.549072 13.5136 0.754605 13.8795 1.12046C14.2453 1.48631 14.4508 1.98251 14.4508 2.4999C14.4508 3.01729 14.2453 3.51349 13.8795 3.87934L7.94196 9.81684C7.86186 9.89694 7.76149 9.95376 7.6516 9.98124L5.1516 10.6062C4.93861 10.6595 4.71331 10.5971 4.55807 10.4418C4.40283 10.2866 4.34043 10.0613 4.39367 9.84831L5.01867 7.34831C5.04615 7.23842 5.10297 7.13806 5.18307 7.05796L11.1206 1.12046Z" fill="#232B43"/>
</g>
<defs>
<clipPath id="clip0_1894_120">
<rect width="15" height="15"/>
</clipPath>
</defs>
</svg>
`,
        });
    }
  }